import { Card, CardContent, Chip, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import React from "react";
import UtilService from "../../services/UtilService";

export default function CardInvitationHistory({ event, invites, hasReachedGoal }) {
    if (!event || !invites || invites.length === 0) return null;

    // Don't show invitation history if goal is reached
    if (hasReachedGoal) {
        return null;
    }

    const getStatusCaption = (status) => {
        switch (status?.toLowerCase()) {
            case "sent":
                return "We sent an email to your friend";
            case "verified":
                return "He/she clicked the link";
            case "joined":
                return "He/she joined";
            case "rejected":
                return "He rejected";
            default:
                return "";
        }
    };

    return (
        <Grid size={{ xs: 12 }}>
            <Card>
                <CardContent>
                    <Typography variant="h6" gutterBottom>
                        Invitation History
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    <TableContainer component={Paper} variant="outlined">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Sent At</TableCell>
                                    <TableCell>Joined At</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {invites.map((invite) => (
                                    <TableRow key={invite.id}>
                                        <TableCell>{invite.inviteeEmail}</TableCell>
                                        <TableCell>
                                            <Tooltip title={getStatusCaption(invite.status)} arrow>
                                                <Chip
                                                    label={invite.status.toUpperCase()}
                                                    color={
                                                        invite.status === "active" || invite.status === "joined"
                                                            ? "success"
                                                            : invite.status === "verified"
                                                                ? "info"
                                                                : invite.status === "rejected"
                                                                    ? "error"
                                                                    : "default"
                                                    }
                                                    size="small"
                                                />
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell>
                                            {invite.sentAt ? UtilService.formatDate(invite.sentAt) : "-"}
                                        </TableCell>
                                        <TableCell>
                                            {invite.joinedAt ? UtilService.formatDate(invite.joinedAt) : "-"}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Grid>
    );
}

